import React from 'react';
import propTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import moment from 'moment-timezone';
import grayIcon from './images/gray-logo.png';
import './style.css';

function Footer(props) {
  const langProps = Object.assign({}, props);
  delete langProps.classes;
  return (
    <footer
      style={{
        marginLeft:
          props.isSidebarDisplay && !props.isSmallScreen ? '280px' : 'auto',
        padding:
          props.isSidebarDisplay && !props.isSmallScreen ? '0 30px' : 'auto',
        marginTop: 15,
        minWidth: '1200px',
        color: '#777',
        backgroundColor: 'transparent',
      }}
    >
      <div className="container" style={{ padding: '0 20px' }}>
        <div className="footer-container">
          <div className="footer-timezone">UTC {props.companyTimeZone}</div>
          <div className="footer-copyright">
            Copyright © {moment.tz(props.timezone).year()} MAYO Human Capital
            Inc. All rights reserved.
            {props.showPrivacy !== false && (
              <span className="footer-copyright-divider">/</span>
            )}
            {props.showPrivacy !== false && (
              <a
                className="footer-link"
                href="/privacy"
                onClick={(event) => {
                  if (props.leaveWarnHandler) {
                    const nextpath =
                      event.target.pathname ||
                      event.target.parentElement.pathname;
                    props.leaveWarnHandler(() => {
                      window.location.href = nextpath;
                    });
                    event.preventDefault();
                  }
                }}
              >
                <FormattedMessage
                  id="SH_PrivacyPolicy"
                  defaultMessage="隱私權政策"
                />
              </a>
            )}
            <span className="footer-copyright-divider">/</span>
            <a
              className="footer-link"
              href="http://www.mayohr.com"
              target="blank"
            >
              About Us
            </a>
          </div>
          <div className="footer-powered-by">
            <span style={{ verticalAlign: 'middle' }}>Powered by</span>
            <img src={grayIcon} height={13} alt="tube-logo" />
          </div>
        </div>
      </div>
    </footer>
  );
}

Footer.propTypes = {
  showPrivacy: propTypes.bool,
  isSidebarDisplay: propTypes.bool,
  isSmallScreen: propTypes.bool,
  companyTimeZone: propTypes.string,
  timezone: propTypes.string,
};

export default Footer;



/** WEBPACK FOOTER **
 ** D:/a/1/s/src/components/Footer/index.js
 **/